import { ActivePanelManager, SplitPanel } from '@infotech-soe/erp-ui-kit';
import React, { memo, useMemo, useRef } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { CategoryTreeType } from '../../../services/category/view-model/CategoryViewModel';
import CatalogsTreeContainer from '../dm-tree/CatalogsTreeContainer';
import HierarchyTreeContainer from '../dm-tree/HierarchyTreeContainer';

import { CategoryContainerProps } from './CategoryContainer';
import CategoryLayoutElementContainer from './CategoryLayoutElementContainer';

const messages = defineMessages({
  [CategoryTreeType.CATALOGS]: {
    id: 'core.category.tree.catalogs',
    defaultMessage: 'Catalogs',
  },
  [CategoryTreeType.HIERARCHY]: {
    id: 'core.category.tree.hierarchy',
    defaultMessage: 'Hierarchy',
  },
});

const Category: React.FC<CategoryContainerProps> = ({
  id,
  layoutRoot,
  showCommands,
  treePanelSize,
  treeType,
  onResize,
}) => {
  const { formatMessage } = useIntl();
  const defaultSize = useRef<number>(treePanelSize ?? 15);

  const TreeContainer =
    treeType === CategoryTreeType.CATALOGS
      ? CatalogsTreeContainer
      : HierarchyTreeContainer;

  const rootElement = useMemo(
    () => (
      <CategoryLayoutElementContainer
        categoryId={id}
        elementId={layoutRoot}
        showCommands={showCommands}
      />
    ),
    [id, layoutRoot, showCommands]
  );

  return (
    <ActivePanelManager.Container id={id}>
      {treeType === CategoryTreeType.NONE ? (
        rootElement
      ) : (
        <SplitPanel
          horizontal
          defaultSize={defaultSize.current}
          onResize={onResize}
        >
          <ActivePanelManager.Panel tabIndex={0}>
            <TreeContainer
              treeId={id}
              className={ActivePanelManager.helpers.target}
              title={formatMessage(messages[treeType])}
            />
          </ActivePanelManager.Panel>
          {rootElement}
        </SplitPanel>
      )}
    </ActivePanelManager.Container>
  );
};

export default memo(Category);
